export default "__VITE_ASSET__BX8QtZ7Y__"